export default __webpack_public_path__ + "static/media/football_icon.efdfdd57.png";